export default "__VITE_ASSET__6234f40e__"